import { cn } from "@tine/designsystem-utils";
import { observer } from "mobx-react-lite";

type LineSeparatorProps = {
   className?: string;
   margin?: "sm" | "md" | "lg" | "none";
};

const Divider = ({ className = "", margin = "md" }: LineSeparatorProps) => {
   const lineSeparatorStyle = "border-solid border-0 border-t border-ink-border-subtle";
   const lineMargin = {
      sm: "my-4",
      md: "my-6",
      lg: "my-8",
      none: ""
   }[margin];

   return <div className={cn(className, lineSeparatorStyle, lineMargin)} />;
};

export default observer(Divider);
